import {defineAction} from 'redux-define';
import {createAction, handleActions} from 'redux-actions';
import get from 'lodash.get';

const namespace = 'flows/interest';

const PERSIST = defineAction('PERSIST', namespace);
export const persist = createAction(PERSIST.ACTION);

// Selectors
export const selectInterest = store => store.flows.interest;
export const selectInvestor = store => get(selectInterest(store), 'investor');
export const selectAllocationSaving = store => get(selectInterest(store), 'allocation.saving');
export const selectAfter = store => get(selectInterest(store), 'after');
export const selectConfirmationToast = store => get(selectInterest(store), 'confirmationToast');

const initialState = {};
export const reducer = handleActions({
  [PERSIST.ACTION]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/reducer.js